export default __webpack_public_path__ + "static/media/afrofashion.c00f111e.png";